import { AssetStatus } from 'src/redux/slices/Assets/Type'
import { getLatestData } from '../Utils/GetLatestData'
import { WizardContext, WizardEvent } from '../wizardMachine'

/**
 * @description return true if asset status is closed
 * @returns boolean
 */
export const isAssetClosed = (context: WizardContext, event: WizardEvent): boolean => {
  const { asset } = getLatestData(context, event)
  if (asset) {
    if (asset.status === AssetStatus.CLOSED) {
      return true
    }
  }

  return false
}
